import { lazy } from "react";

/** Code-split heavy or infrequent pages for faster initial load. */
export const LoginPage = lazy(() =>
  import("@/pages/login").then((m) => ({ default: m.LoginPage }))
);
export const ForgotPasswordPage = lazy(() =>
  import("@/pages/forgotpassword").then((m) => ({
    default: m.ForgotPasswordPage,
  }))
);
export const CompanyFormPage = lazy(() =>
  import("@/pages/companies/form").then((m) => ({ default: m.CompanyFormPage }))
);
export const DashboardPage = lazy(() =>
  import("@/pages/dashboard").then((m) => ({ default: m.DashboardPage }))
);
export const UpgradePackagePage = lazy(() =>
  import("@/pages/upgrade/UpgradePackagePage").then((m) => ({
    default: m.UpgradePackagePage,
  }))
);
export const EmployeesPage = lazy(() =>
  import("@/pages/employees").then((m) => ({ default: m.EmployeesPage }))
);
export const EmployeeFormPage = lazy(() =>
  import("@/pages/employees/form").then((m) => ({ default: m.EmployeeFormPage }))
);
export const EmployeeScansPage = lazy(() =>
  import("@/pages/employees/scans").then((m) => ({ default: m.EmployeeScansPage }))
);
export const CompaniesPage = lazy(() =>
  import("@/pages/companies").then((m) => ({ default: m.CompaniesPage }))
);
export const CompanyScansPage = lazy(() =>
  import("@/pages/companies/scans").then((m) => ({ default: m.CompanyScansPage }))
);
export const IndividualsPage = lazy(() =>
  import("@/pages/individuals").then((m) => ({ default: m.IndividualsPage }))
);
export const IndividualScansPage = lazy(() =>
  import("@/pages/individuals/scans").then((m) => ({ default: m.IndividualScansPage }))
);
export const PackagesPage = lazy(() =>
  import("@/pages/packages").then((m) => ({ default: m.PackagesPage }))
);
export const PackageFormPage = lazy(() =>
  import("@/pages/packages/form").then((m) => ({ default: m.PackageFormPage }))
);
export const UsersPage = lazy(() =>
  import("@/pages/users").then((m) => ({ default: m.UsersPage }))
);
export const UserFormPage = lazy(() =>
  import("@/pages/users/form").then((m) => ({ default: m.UserFormPage }))
);
export const LicensesPage = lazy(() => import("@/pages/licenses"));
export const InvoicesPage = lazy(() => import("@/pages/invoices"));
export const LookupsPage = lazy(() => import("@/pages/lookup"));
export const LookupFormPage = lazy(() =>
  import("@/pages/lookup/form").then((m) => ({ default: m.LookupFormPage }))
);
export const ContactUsPage = lazy(() =>
  import("@/pages/contactUs").then((m) => ({ default: m.ContactUsPage }))
);
export const ContactUsFormPage = lazy(() =>
  import("@/pages/contactUs/form").then((m) => ({ default: m.ContactUsFormPage }))
);
export const PaymentResultPage = lazy(() =>
  import("@/pages/payment/paymentResult").then((m) => ({
    default: m.PaymentResultPage,
  }))
);
export const HomePage = lazy(() => import("@/pages/website/Home"));
export const PricingPage = lazy(() => import("@/pages/website/Pricing"));
export const FeaturesPage = lazy(() => import("@/pages/website/Features"));
export const AboutPage = lazy(() => import("@/pages/website/About"));
export const ContactPage = lazy(() => import("@/pages/website/Contact"));
export const FaqPage = lazy(() => import("@/pages/website/Faq"));
export const DemoPage = lazy(() => import("@/pages/website/Demo"));
export const PrivacyPage = lazy(() => import("@/pages/website/Privacy"));
export const DataPolicyPage = lazy(() => import("@/pages/website/DataPolicy"));
export const TermsPage = lazy(() => import("@/pages/website/Terms"));
export const NotFoundPage = lazy(() =>
  import("@/pages/NotFound").then((m) => ({ default: m.NotFoundPage }))
);
export const PublicEmployeePage = lazy(() => import("@/pages/employees/public"));
export const PublicIndividualPage = lazy(() => import("@/pages/individuals/public"));
